import * as React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

const PhotoFrameImage = styled(Img).attrs(() => ({
  className: 'shadow-2xl border-8 border-white',
}))``;

export default PhotoFrameImage;